// The selection range for curated experts on a StoryIdea. The model
// (`MatchFeed::StoryIdea::EXPERT_SELECTION_RANGE = 2..5`) is the source
// of truth; this is the frontend mirror. Kept in one place so the
// picker, the form's validation, and the tooltip copy can't drift apart.
export const MIN_EXPERTS = 2;
export const MAX_EXPERTS = 5;
